import { Link } from '@/ui/Link';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

type Props = {
  active?: boolean;
};

export const SearchButton = ({ active }: Props) => {
  return (
    <Link
      href="/search"
      className={
        active
          ? 'text-text-highlight'
          : 'text-white opacity-70 hover:opacity-100'
      }
    >
      <MagnifyingGlassIcon className="h-6 w-6" />
    </Link>
  );
};
